import React from "react";

import moment from "moment";

const RRConsumo = ({consumo, verDetalles, setShowInfo}) =>{

    return <div className='container-r-list-item consumoRow'>
        <div className='container-r-list-item-header'>
            <div className='r-list-item-header-clave'>{consumo.tDocCodFor} - {consumo.tDocNroFor}</div>
            <div className='r-list-item-header-title'>{consumo.title}</div>
        </div>
        <div className='container-r-list-item-details'>
            <div className='r-list-item-details-title'>Fecha de Alta: {moment(consumo.fecAlt).format('DD-MM-YYYY HH:MM')}</div>
            <div className='r-list-item-details-title'>Usuario: {consumo.userName}</div>
        </div>
        <div className='container-r-list-item-btn'>
            <div className='r-list-item-btn-A' onClick={() => verDetalles(consumo)}>Detalles</div>
        </div>
    </div>
}

export default RRConsumo;